import { getScoreSuffix, getScoreText } from "#webapp/src/util/event-score-delta.util";
import React from "react";
import {
  EventSchedulingQueryImpact,
  EventSchedulingQueryPerson,
  PersonImpact,
} from "./EventScheduling";

export type GetNamePersonImpact = PersonImpact;
export type GetNamePerson = EventSchedulingQueryPerson;
export const getName = (person: EventSchedulingQueryPerson, personImpact: GetNamePersonImpact) =>
  !!person && !!person.profile
    ? `${person.profile.givenName} ${person.profile.familyName}`
    : personImpact.calendarId;

export type FocusTimeTooltipImpacts = Pick<EventSchedulingQueryImpact, "focusTimeMinutesCost">;
function FocusTimeTooltip({
  impacts,
  name,
}: {
  impacts: FocusTimeTooltipImpacts | undefined;
  name: string;
}) {
  if (!impacts) {
    return (
      <span>
        {name}:<br />
        Focus Time impact not calculated
      </span>
    );
  }

  const { focusTimeMinutesCost } = impacts;
  const score = -focusTimeMinutesCost / 60;

  return (
    <span>
      {name}:<br />
      {getScoreText(score)}
      {getScoreSuffix(score)}
    </span>
  );
}

export default FocusTimeTooltip;
